import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-project-cell',
    template: `
        <div class="row">
            <div class="col-4 text-center">
                <div *ngIf="params.data.client && params.data.client.logoUrl">
                    <img class="img-avatar img-avatar16 mt-5 mr-5" src="{{params.data.client.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">
                </div>
                <div *ngIf="!params.data.client && params.data.project.client && params.data.project.client.logoUrl">
                    <img class="img-avatar img-avatar16 mt-5 mr-5" src="{{params.data.project.client.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">
                </div>
            </div>
            <div class="col-8">
                <a *ngIf="params.data.projectName" [routerLink]="['/projects', params.data._id]">{{ params.data.projectName }}</a>
                <a *ngIf="!params.data.projectName && params.data.project.projectName" [routerLink]="['/projects', params.data.project._id]">{{ params.data.project.projectName }}</a>
            </div>
        </div>
    `,
})
export class ProjectCellRendererComponent implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        // console.log('these are the params', params);
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

}



// WEBPACK FOOTER //
// ./client/app/shared/grid/cell-renderers/project-cell-renderer.component.ts